<template>
<m-pageframe
    title="{organization-label}: Lightbox URL(s)"
>
<v-container
    fluid
    v-if="lightboxes != null"
>
    <m-edit-lightbox-url
            v-for="(item, index) in lightboxes.urls"
            :key="index"
            :value="item"
            :index="index"
            :lightboxes="lightboxes"
            v-on:input="onChangeUrl"
            v-on:move-up="onClickMoveUp"
            v-on:move-down="onClickMoveDown"
            v-on:delete="onDelete"
            v-on:create-new="onClickCreateUrl"
        />

    <div
        style="text-align: right"
    >
        <v-btn 
            class="mx-2" fab dark small color="primary"
            v-on:click="onClickCreateUrl({})"
        >
            <v-icon dark>mdi-plus</v-icon>
        </v-btn>
    </div>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');

export default {
    data() {
        return {
            lightboxes: null,
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/lightbox/organization/:organization_id',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },
            
                'on_success': (data) => {
                        this.lightboxes = data;
                    },
            
                'on_error': 'Unable to list lightbox url(s)',
            });
        },

        onClickMoveUp(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/lightbox/url/move-up',
            
                'params' : {
                        'organization_id': item.organization_id,
                        'url_id': item.url_id,
                    },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to move URL up',
            });
        },

        onClickMoveDown(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/lightbox/url/move-down',
            
                'params' : {
                        'organization_id': item.organization_id,
                        'url_id': item.url_id,
                    },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to move URL down',
            });
        }, 

        onChangeUrl(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/lightbox/url',
            
                'params' : item,
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to save URL',
            });
        },

        onDelete(item)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'DELETE: /api/v1/lightbox/url',
            
                'params' : {
                    'organization_id': item.organization_id,
                    'url_id': item.url_id,
                },
            
                'on_success': (data) => {
                        this.doUpdate();
                    },
            
                'on_error': 'Unable to delete URL',
            });
        },

        onClickCreateUrl(params)
        {
            this.$rc.pick({
                'title': '',
                'content_before': 'Pick a lightbox',
                'content_after': null,
            
                'choices': this.lightboxes.settings
                                .map(item => { return { 'text': item.label, 'value': item.lightbox_id} })
                ,
            
                'multiple': false,
                'type': 'select',
                'select_label': 'Lightbox',
                'initial_value': null,
                'unset_label': null,
            
                'on_ok': (value) => {
                    this.doCreateUrl(value, params)
                 },
            
                'on_cancel': () => {}
            
            });
        },

        doCreateUrl(lightbox_id, params)
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/lightbox/url/create-stub',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'lightbox_id': lightbox_id,
                        ...params
                    },
            
                'on_success': (data) => {
                        this.doUpdate();  
                    },
            
                'on_error': 'Unable to create new url',
            });
        }
        
    },
}
</script>

<style lang="scss" scoped>
</style>